import { render, staticRenderFns } from "./UpLive.vue?vue&type=template&id=7629ec9b&"
import script from "./UpLive.vue?vue&type=script&lang=js&"
export * from "./UpLive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports